import React, { useState, useEffect } from "react";
import {useApiManager} from "lib/ApiContext";
import EventNeonCard from "./EventNeonCard"
import {Stack, Box, Typography, Skeleton} from '@mui/material';



const EventList = () => {

    const [publishEvents, setPublishEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const api = useApiManager();

    const fetchData = async () =>{
        try {
            const data = await api.GetEvents();
            setPublishEvents(data.Events || []);
        }
        catch (error){
            console.error("❌ Error al cargar los eventos:", error);
            setPublishEvents([]);
        }
        finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    },[]);

    if (loading) {
        return (
            <Stack direction="row" spacing={2} justifyContent="center" sx={{ flexWrap: "wrap", gap: 2 }}>
                {[1, 2, 3].map(i => (
                    <Skeleton key={i} variant="rounded" width={300} height={340} />
                ))}
            </Stack>
        );
    }

    if (publishEvents.length === 0) {
        return (
            <Box sx={{ textAlign: "center", py: 8 }}>
                <Box
                    component="img"
                    src="/images/empty-events.webp"
                    alt=""
                    sx={{ width: 180, maxWidth: "60%", borderRadius: "10px", mb: 2 }}
                />
                <Typography variant="h4" sx={{ color: "text.secondary", mb: 1 }}>
                    No hay eventos próximos
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    Pronto anunciaremos nuevos eventos — seguinos en redes para enterarte primero
                </Typography>
            </Box>
        );
    }

    return <Stack direction="row" spacing={2}
                            justifyContent="center"
                            alignItems="stretch"
                            sx={{ flexWrap: "wrap", gap: 2 }}
                            >
                {publishEvents.map((e) => (
                    <EventNeonCard key={e.EventID} event={e} />
                    ))
                }
           </Stack>;
}

export default EventList;
